import { render, staticRenderFns } from "./SalesOverview.vue?vue&type=template&id=ec65acf0"
import script from "./SalesOverview.vue?vue&type=script&lang=ts"
export * from "./SalesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports